/**
 * ภูเขายอดหมอก: Taoist and flowing, like clouds over the peaks and 太极 turning. The zheng ripples
 * without a break, the xiao floats over it, the qin answers in harmonics; a bronze bowl.
 */
import { arp, drone, octave } from '../compose';
import { registerTrack } from '../registry';

const A_XIAO = `@mf 5,- 6, 1 | 2. 3_ 2 1 | 6,_ 1_ 2_ 3_ 5- | 3_ 2_ 1- 0 ; |
  5. 6_ 5_ 3_ 2 | 3_ 5_ 6 5_ 3_ 2 | 1_ 2_ 3_ 1_ 6,_ 1_ 2 | 5,---`;
const A_QIN = `@mp 5,,/--- | 1,--- | 2,~--- | 5,,--- | 6,,/--- | 3,--- | 1,\\--- | 5,,~---`;
const ROOTS_A = `5,, 1, 2, 5,, 6,, 3, 1, 5,,`;
const FLOW = [0, 2, 3, 5, 7, 5, 3, 2];

const B_QIN = `@mf 5* 6* 1'*- | 2'*_ 1'*_ 6*_ 5*_ 3*- | 5,. 6,_ 1/ 2 | 1\\--- |
  6,. 1_ 2 3/ | 5- 3_ 2_ 1 | 2_ 3_ 2_ 1_ 6, 1 | 5,~---`;
const B_XIAO = `@p 0--- | 0- 5- | 0--- | 0- 3_ 2_ 1 | 0--- | 0- 6, 1 | 0--- | 5,---`;
const ROOTS_B = `1, 6,, 5,, 1, 6,, 1, 2, 5,,`;

const BOWL = `b--- | 0--- | 0--- | 0--- | b--- | 0--- | 0--- | 0---`;

registerTrack({
  id: 'mist-peak',
  order: 6,
  title: 'เมฆไหลผ่านยอดหมอก',
  mood: 'ไหลลื่น สงบ เต๋า',
  use: 'ภูเขายอดหมอก (สำนักยอดหมอก)',
  key: 'F',
  mode: 'zhi',
  bpm: 66,
  meter: 4,
  seed: 606,
  parts: {
    xiao: { inst: 'xiao', pan: -0.15, reverb: 0.5 },
    qin: { inst: 'qin', gain: 0.9, pan: 0.1, reverb: 0.45 },
    harp: { inst: 'zheng', gain: 0.42, pan: 0.25, reverb: 0.4 },
    pad: { inst: 'pad', gain: 0.6, reverb: 0.5 },
    bowl: { inst: 'perc', gain: 0.2, pan: -0.3, reverb: 0.6 },
  },
  sections: {
    A: {
      bars: 8,
      parts: { xiao: A_XIAO, qin: A_QIN, harp: arp(ROOTS_A, FLOW), pad: drone(ROOTS_A, 4), bowl: BOWL },
    },
    B: {
      bars: 8,
      parts: {
        qin: B_QIN,
        xiao: B_XIAO,
        harp: arp(ROOTS_B, [0, null, 3, null, 5, null, 3, null]),
        pad: drone(ROOTS_B, 4),
        bowl: BOWL,
      },
    },
    A2: {
      bars: 8,
      parts: {
        xiao: octave(A_XIAO, 1),
        qin: A_QIN,
        harp: arp(ROOTS_A, [0, 3, 5, 7, 8, 7, 5, 3]),
        pad: drone(ROOTS_A, 4),
        bowl: BOWL,
      },
    },
  },
  form: ['A', 'B', 'A2', 'B'],
  loop: true,
});
